module.exports = __webpack_public_path__ + "img/68_42.4d1cdfa7.png";